module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row small-collapse",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.intro))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.iAmA == 'individual'),
      expression: "this.iAmA == 'individual'"
    }],
    staticClass: "read-letter",
    attrs: {
      "type": "button",
      "value": "Here's the message we're sending"
    },
    on: {
      "click": _vm.openReadLetterPage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns left-field"
  }, [_c('label', {
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("\n        First name\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lead.firstName),
      expression: "lead.firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "type": "text",
      "name": "firstName",
      "id": "firstName",
      "data-vv-as": "first name"
    },
    domProps: {
      "value": (_vm.lead.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lead, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('firstName')) ? _c('span', {
    staticClass: "form-error-area"
  }, [_c('p', [_vm._v(_vm._s(_vm.errors.first("firstName")))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns right-field"
  }, [_c('label', {
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("\n        Last name\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lead.lastName),
      expression: "lead.lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "type": "text",
      "name": "lastName",
      "id": "lastName",
      "data-vv-as": "last name"
    },
    domProps: {
      "value": (_vm.lead.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lead, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('lastName')) ? _c('span', {
    staticClass: "form-error-area"
  }, [_c('p', [_vm._v(_vm._s(_vm.errors.first("lastName")))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 left-field columns"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("\n        Email\n        "), _c('div', {
    staticClass: "with-input-loading"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lead.email),
      expression: "lead.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        earthhourEmailIsValid: true,
        email: true,
      }),
      expression: "{\n              required: true,\n              earthhourEmailIsValid: true,\n              email: true,\n            }"
    }],
    class: {
      'border-red': _vm.errors.has('email')
    },
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "data-vv-as": "email"
    },
    domProps: {
      "value": (_vm.lead.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lead, "email", $event.target.value)
      }, function($event) {
        _vm.onEmailInput()
      }]
    }
  }), _vm._v(" "), (
    _vm.emailCheckSensis.checkEmailLoading ||
    _vm.emailCheckDuplicate.checkEmailLoading
  ) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/2612/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.errors.first('email')) ? _c('span', {
    staticClass: "form-error-area"
  }, [_c('p', [_vm._v(_vm._s(_vm.errors.first("email")))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 right-field columns"
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("\n        Phone\n        "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        earthhourPhoneNumberIsValid: true
      }),
      expression: "{ required: true, earthhourPhoneNumberIsValid: true }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.lead.phone),
      expression: "lead.phone"
    }],
    class: {
      'border-red':
      _vm.errors.has('phone') ||
        _vm.errors.has('earthhourPhoneNumberIsValid'),
    },
    attrs: {
      "type": "tel",
      "name": "phone",
      "id": "phone",
      "data-vv-as": "phone"
    },
    domProps: {
      "value": (_vm.lead.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lead, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('phone')) ? _c('span', {
    staticClass: "form-error-area"
  }, [_c('p', [_vm._v(_vm._s(_vm.errors.first("phone")))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns left-field"
  }, [_c('label', {
    attrs: {
      "for": "postcode"
    }
  }, [_vm._v("\n        Postcode\n        "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.lead.postCode),
      expression: "lead.postCode"
    }],
    class: {
      'border-red': _vm.errors.has('postcode')
    },
    attrs: {
      "type": "tel",
      "name": "postcode",
      "id": "postcode",
      "data-vv-as": "postcode"
    },
    domProps: {
      "value": (_vm.lead.postCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.lead, "postCode", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('postcode')) ? _c('span', {
    staticClass: "form-error-area"
  }, [_c('p', [_vm._v(_vm._s(_vm.errors.first("postcode")))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns right-field"
  }, [_c('label', {
    attrs: {
      "for": "iAmA"
    }
  }, [_vm._v("\n        I am " + _vm._s(_vm.iAmA == "individual" || _vm.iAmA == "organisation" ? "an" : "a") + "\n        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.iAmA),
      expression: "iAmA"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('iAmA')
    },
    attrs: {
      "name": "iAmA",
      "data-vv-as": "I am"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.iAmA = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "individual"
    }
  }, [_vm._v("Individual")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "school"
    }
  }, [_vm._v("School")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "council"
    }
  }, [_vm._v("Council")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "business"
    }
  }, [_vm._v("Business")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "landmark"
    }
  }, [_vm._v("Landmark")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "organisation"
    }
  }, [_vm._v("Organisation")])]), _vm._v(" "), (_vm.errors.first('iAmA')) ? _c('span', {
    staticClass: "form-error-area"
  }, [_c('p', [_vm._v(_vm._s(_vm.errors.first("iAmA")))])]) : _vm._e()])]), _vm._v(" "), (_vm.showCompetition && _vm.iAmA && _vm.iAmA == 'individual') ? _c('div', {
    staticClass: "small-12 columns"
  }, [_c('div', {
    staticClass: "wwf-checkbox",
    attrs: {
      "checked": "checked"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isInCompetition),
      expression: "isInCompetition"
    }],
    attrs: {
      "type": "checkbox",
      "id": "in-competition",
      "name": "in-competition"
    },
    domProps: {
      "checked": Array.isArray(_vm.isInCompetition) ? _vm._i(_vm.isInCompetition, null) > -1 : (_vm.isInCompetition)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isInCompetition,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isInCompetition = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isInCompetition = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isInCompetition = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox"
  }), _vm._v("\n          " + _vm._s(_vm.competitionText) + "\n        ")])])]) : _vm._e(), _vm._v(" "), (_vm.showCompetition && _vm.iAmA && _vm.iAmA == 'individual') ? _c('div', {
    staticClass: "small-12 columns"
  }, [_c('div', {
    staticClass: "wwf-checkbox",
    attrs: {
      "checked": "checked"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.acceptContactFonzarelli),
      expression: "acceptContactFonzarelli"
    }],
    attrs: {
      "type": "checkbox",
      "id": "accept-contact-fonzarelli",
      "name": "accept-contact-fonzarelli"
    },
    domProps: {
      "checked": Array.isArray(_vm.acceptContactFonzarelli) ? _vm._i(_vm.acceptContactFonzarelli, null) > -1 : (_vm.acceptContactFonzarelli)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.acceptContactFonzarelli,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.acceptContactFonzarelli = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.acceptContactFonzarelli = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.acceptContactFonzarelli = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox"
  }), _vm._v("\n          Receive inspiration and special offers from Fonz Moto\n        ")])])]) : _vm._e(), _vm._v(" "), (_vm.iAmA && _vm.iAmA != 'individual') ? _c('div', {
    staticClass: "small-12 columns"
  }, [_c('label', {
    attrs: {
      "for": "othername"
    }
  }, [_vm._v("\n        Name of the " + _vm._s(_vm.iAmA) + "\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.othername),
      expression: "othername"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('othername')
    },
    attrs: {
      "type": "text",
      "name": "othername",
      "id": "othername",
      "data-vv-as": 'name of the ' + this.iAmA
    },
    domProps: {
      "value": (_vm.othername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.othername = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first('othername')) ? _c('span', {
    staticClass: "form-error-area"
  }, [_c('p', [_vm._v(_vm._s(_vm.errors.first("othername")))])]) : _vm._e()]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "logoInput"
    }
  }, [_vm._v("\n        Update your logo here (Not mandatory)\n\n        "), _vm._v(" "), _c('input', {
    ref: "logoInput",
    attrs: {
      "type": "file",
      "name": "logoInput",
      "id": "logoInput",
      "size": _vm.fileUpload.maxSize,
      "accept": ".png, .jpg, .jpeg, .gif",
      "disabled": _vm.isSaving
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.files)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "file-label",
    attrs: {
      "for": "logoInput"
    }
  }, [(_vm.isClean) ? _c('span', [_c('i', {
    staticClass: "fas fa-file"
  }), _vm._v(" Choose a file... (Max 1Mb)\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.isClean) ? _c('span', [_vm._v(_vm._s(_vm.fileUpload.fileName) + " selected... ")]) : _vm._e(), _vm._v(" "), (_vm.hasError) ? _c('span', {
    staticClass: "alert-box"
  }, [_vm._v("\n            " + _vm._s(_vm.fileUpload.error) + "\n          ")]) : _vm._e()])]), _vm._v(" "), (!_vm.isClean && _vm.fileUpload.source) ? _c('div', {
    staticClass: "preview-container"
  }, [_c('div', {
    staticClass: "img-delete"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeImage
    }
  }, [_c('i', {
    staticClass: "fas fa-times fw"
  })])]), _vm._v(" "), _c('img', {
    staticClass: "preview-image",
    attrs: {
      "src": _vm.fileUpload.source
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isProfanity),
      expression: "isProfanity"
    }],
    staticClass: "small-12 columns"
  }, [_c('span', {
    staticClass: "alert-box"
  }, [_vm._v(" No bad words! Please change your name. ")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }, [_c('div', {
    staticClass: "submit-bttn bttn-lrg"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": !_vm.isSaving ? _vm.buttontitle : 'Loading...'
    },
    on: {
      "click": _vm.save
    }
  })])]), _vm._v(" "), (_vm.showcounter) ? _c('div', {
    staticClass: "small-12 columns counter-area"
  }, [_c('h2', [_c('count-to', {
    ref: "counter",
    attrs: {
      "startVal": _vm.startcounter,
      "end-val": _vm.endcounter,
      "autoplay": false,
      "duration": 7000
    }
  })], 1), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.countertitle))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "privacy-statement"
  }, [_vm._m(0, false, false), _vm._v(" "), (_vm.showCompetition && _vm.iAmA && _vm.iAmA == 'individual') ? _c('p', [_vm._v("\n      Competiton\n      "), _c('a', {
    attrs: {
      "href": _vm.competitionPrivacyPolicy,
      "target": "_blank"
    }
  }, [_vm._v("\n        Terms and Conditions\n      ")])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      By signing you accept\n      "), _c('a', {
    attrs: {
      "href": "/privacy-policy/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("WWF-Australia’s Privacy Policy.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d656a98","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=bhy68egj1x!./~/string-replace-webpack-plugin/loader.js?id=wgppdwdx8dq!./src/components/earth-hour/EarthhourRegistration.vue
// module id = 634
// module chunks = 0